import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/ChipFilterToggle.module.scss';
import IconArrowDown from '@/asset/superstack/svgs/icon-arrow-down.svg';
import IconArrowUp from '@/asset/superstack/svgs/icon-arrow-up.svg';
import PropTypes from 'prop-types';

const ChipFilterToggle = ({ mode, size, num, handleModalOpen, isModalOpen, ...props }) => {
  const cx = classNames.bind(styles);
  const cns = [`chip--${mode}`, `chip--${size}`];
  const IconArrow = isModalOpen ? IconArrowUp : IconArrowDown;
  return (
    <button onClick={handleModalOpen} className={cx(cns)} {...props}>
      <div className={cx('content-box')}>
        <div className={cx('content-with-icon')}>{props.children}</div>
        {num > 0 && <span className={cx('content-num')}>{num}</span>}
        <IconArrow width={14} height={9} fill={'#212121'} />
      </div>
    </button>
  );
};

ChipFilterToggle.propTypes = {
  mode: PropTypes.oneOf(['normal', 'hover', 'active']),
  /**
   * How large should the button be?
   */
  size: PropTypes.oneOf(['md']),
};

ChipFilterToggle.defaultProps = {
  mode: 'normal',
  size: 'md',
  children: '칩칩',
};

export { ChipFilterToggle };
